"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _styles = require("@eig-builder/core-ui/styles");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _Button = _interopRequireDefault(require("@eig-builder/core-ui/Button"));

var _helpers = require("@eig-builder/module-modals/helpers");

var _context = _interopRequireDefault(require("@eig-builder/module-modals/context"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _context2 = _interopRequireDefault(require("@eig-builder/module-localization/context"));

var _dataGridContext = require("../../data-grid-context");

require("./lang");

var dataElementPrefix = 'datatable-multiple-select-';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    multipleSelectBar: {
      boxShadow: "rgba(0, 0, 0, 0.12) 0 1px 6px, rgba(0, 0, 0, 0.12) 0 1px 4px",
      "& .multiple": {
        display: "inline-block",
        paddingLeft: "15px"
      },
      "& .multiple-item, & .list-page-detail-back, & .multiple-select-text, & .multiple-delete-button, & .remove-from-category-button": {
        display: "inline-block"
      },
      "& .multiple-select-text": {
        span: {
          color: "$primitive-text-secondary",
          verticalAlign: "middle"
        }
      },
      "& .remove-from-category-button, & .multiple-moveto": {
        "float": "right"
      }
    },
    columnBtn: {
      display: "inline-block",
      transition: "background-color $short-animation-time ease-in-out",
      "& .icon": {
        color: "$primitive-text-secondary !important",
        verticalAlign: "baseline"
      },
      "& .active": {
        backgroundColor: "$navbar-active-background-color"
      },
      "&:hover": {
        "& .icon": {
          color: "$primitive-text-primary !important"
        },
        backgroundColor: "$navbar-active-background-color",
        cursor: "pointer"
      }
    }
  };
});

var MultipleSelectComponent = function MultipleSelectComponent(_ref) {
  var activeCategoryLabel = _ref.activeCategoryLabel,
      cancelMultipleSelection = _ref.cancelMultipleSelection,
      multipleSelectCount = _ref.multipleSelectCount,
      categoryFilter = _ref.categoryFilter,
      pageCount = _ref.pageCount,
      sorting = _ref.sorting,
      tag = _ref.tag,
      data = _ref.data,
      multipleDelete = _ref.multipleDelete,
      removeMultipleFromCategory = _ref.removeMultipleFromCategory,
      multipleMoveProductToTop = _ref.multipleMoveProductToTop,
      multipleMoveProductToBottom = _ref.multipleMoveProductToBottom,
      multipleMoveTo = _ref.multipleMoveTo;

  var _useContext = (0, _react.useContext)(_context2["default"]),
      localize = _useContext.localize;

  var _useContext2 = (0, _react.useContext)(_context["default"]),
      dispatch = _useContext2.dispatch;

  var _useDataGridContext = (0, _dataGridContext.useDataGridContext)(),
      selectedNodes = _useDataGridContext.selectedNodes,
      setSelectedNodes = _useDataGridContext.setSelectedNodes,
      gridApi = _useDataGridContext.gridApi;

  var deselectNodes = function deselectNodes() {
    setSelectedNodes([]);
    gridApi && gridApi.deselectAll();
  };

  var handleClick = function handleClick(type) {
    var arrSelectedData = selectedNodes.map(function (entry) {
      if (entry.id) {
        return entry.id;
      }
    }).filter(function (entry) {
      return entry;
    }); // Filter out all undefined entries.

    var selectedDataCount = arrSelectedData.length;

    switch (type) {
      case 'multiple-delete':
        (0, _helpers.YesNo)({
          title: localize('core.components.datatable.multipleSelect.deleteTitle'),
          content: localize('core.components.datatable.multipleSelect.deleteContent'),
          yes: function yes() {
            multipleDelete(arrSelectedData);
            cancelMultipleSelection(deselectNodes);
          }
        })(dispatch);
        break;

      case 'remove-from-category':
        var productPhrase = selectedDataCount > 1 ? 'core.components.datatable.multipleSelect.theseProducts' : 'core.components.datatable.multipleSelect.thisProduct';
        var subCatPhrase = categoryFilter && categoryFilter.length > 1 ? localize('core.components.datatable.multipleSelect.subCategory') : '';
        (0, _helpers.YesNo)({
          title: /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
            message: "core.components.datatable.multipleSelect.categoryTitle",
            values: [localize(productPhrase), activeCategoryLabel]
          }),
          content: /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
            message: "core.components.datatable.multipleSelect.categoryContent",
            values: [localize(productPhrase), activeCategoryLabel, subCatPhrase]
          }),
          yes: function yes() {
            removeMultipleFromCategory(categoryFilter[0], arrSelectedData);
            cancelMultipleSelection(deselectNodes);
          }
        })(dispatch);
        break;

      case 'multiple-moveto':
        if (multipleMoveTo) {
          multipleMoveTo(arrSelectedData);
          deselectNodes();
        }

        break;

      case 'multiple-move-to-top':
        if (multipleMoveProductToTop) {
          multipleMoveProductToTop(arrSelectedData.reverse());
          deselectNodes();
        }

        break;

      case 'multiple-move-to-bottom':
        if (multipleMoveProductToBottom) {
          multipleMoveProductToBottom(arrSelectedData);
          deselectNodes();
        }

        break;
    }
  };

  var isOrderSorting = (0, _isEmpty["default"])(sorting);
  var classes = useStyles();

  if (selectedNodes.length > 0) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.multipleSelectBar
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "list-page-detail-back"
    }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      onClick: function onClick() {
        return cancelMultipleSelection(deselectNodes);
      },
      dataElementLocation: _taggingHelper.DataElementLocations.BODY,
      dataElementLabel: "".concat(dataElementPrefix, "detail-back-").concat(tag),
      dataElementId: "".concat(dataElementPrefix, "detail-back-").concat(tag)
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "arrow_back"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "multiple-select-text"
    }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
      message: "core.components.datatable.multipleSelect.title",
      values: [selectedNodes.length]
    })), isOrderSorting && /*#__PURE__*/_react["default"].createElement("div", {
      className: "multiple"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "multiple-item"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "column-btn",
      "data-balloon": localize('core.components.datatable.multipleSelect.moveToTop'),
      "data-balloon-pos": "up"
    }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      onClick: function onClick() {
        return handleClick('multiple-move-to-top');
      },
      dataElementLocation: _taggingHelper.DataElementLocations.BODY,
      dataElementLabel: "".concat(dataElementPrefix, "multiple-moveto-top").concat(tag),
      dataElementId: "".concat(dataElementPrefix, "multiple-moveto-top").concat(tag)
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "arrow_upward"
    })))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "multiple-item"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "column-btn",
      "data-balloon": localize('core.components.datatable.multipleSelect.moveToBottom'),
      "data-balloon-pos": "up"
    }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      onClick: function onClick() {
        return handleClick('multiple-move-to-bottom');
      },
      dataElementLocation: _taggingHelper.DataElementLocations.BODY,
      dataElementLabel: "".concat(dataElementPrefix, "multiple-moveto-bottom-").concat(tag),
      dataElementId: "".concat(dataElementPrefix, "multiple-moveto-bottom-").concat(tag)
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "arrow_downward"
    })))), pageCount > 1 && /*#__PURE__*/_react["default"].createElement("div", {
      className: "multiple-item"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "column-btn",
      "data-balloon": localize('core.components.datatable.multipleSelect.moveto'),
      "data-balloon-pos": "up"
    }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      onClick: function onClick() {
        return handleClick('multiple-moveto');
      },
      dataElementLocation: _taggingHelper.DataElementLocations.BODY,
      dataElementLabel: "".concat(dataElementPrefix, "multiple-moveto-").concat(tag),
      dataElementId: "".concat(dataElementPrefix, "multiple-moveto-").concat(tag)
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "unfold_more"
    }))))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "multiple-delete-button"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "column-btn",
      "data-balloon": localize('core.components.datatable.multipleSelect.delete'),
      "data-balloon-pos": "up"
    }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      onClick: function onClick() {
        return handleClick('multiple-delete');
      },
      dataElementLocation: _taggingHelper.DataElementLocations.BODY,
      dataElementLabel: "".concat(dataElementPrefix, "multiple-delete-").concat(tag),
      dataElementId: "".concat(dataElementPrefix, "multiple-delete-").concat(tag)
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "delete"
    })))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "remove-from-category-button ".concat((0, _isUndefined["default"])(categoryFilter) || (0, _isEmpty["default"])(categoryFilter) || categoryFilter[0] < 1 ? "hidden" : "")
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      color: "secondary",
      onClick: function onClick() {
        return handleClick('remove-from-category');
      },
      dataElementLocation: _taggingHelper.DataElementLocations.BODY,
      dataElementLabel: "".concat(dataElementPrefix, "remove-from-category-").concat(tag),
      dataElementId: "".concat(dataElementPrefix, "remove-from-category-").concat(tag)
    }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
      message: "core.components.datatable.multipleSelect.remove"
    })))));
  } else {
    return null;
  }
};

MultipleSelectComponent.propTypes = {
  tag: _propTypes["default"].string,
  categoryFilter: _propTypes["default"].array,
  data: _propTypes["default"].array,
  multipleDelete: _propTypes["default"].func,
  removeMultipleFromCategory: _propTypes["default"].func,
  cancelMultipleSelection: _propTypes["default"].func,
  activeCategoryLabel: _propTypes["default"].string,
  multipleMoveProductToBottom: _propTypes["default"].func,
  multipleMoveProductToTop: _propTypes["default"].func,
  multipleMoveTo: _propTypes["default"].func,
  pageCount: _propTypes["default"].number,
  sorting: _propTypes["default"].array
};
var _default = MultipleSelectComponent;
exports["default"] = _default;